import widgetsService from 'live/services/widgets'
import TrajectoryIndex from './TrajectoryIndex'

const type = 'trajectory-index'

widgetsService.name(type, 'trajectory-index')
widgetsService.description(type, 'trajectory-index')
widgetsService.impl(type, TrajectoryIndex)
widgetsService.policies(type, {
    layers: 1,
    allowYAxisConfig: false,
    allowGroupedYAxis: false,
    defaultReducer: '@latest'
})
widgetsService.queryHandlerKind(type, 'trajectory-index')
widgetsService.properties(type, {})
widgetsService.config(type, {
    verticalEnabled: false
})
